import { h, render, Fragment } from "preact";
import RichText from "../richText";
import objectPositionFromFocalPoint from "../../helpers/objectPositionFromFocalPoint";

const mapVerticalAlignment = (key) => {
  const map = {
    Top: "start",
    Middle: "center",
    Bottom: "end",
  };

  if (key in map) {
    return map[key];
  }

  return "end";
};

const InterstitialBannerV2 = ({ content, index }) => {
  if (!content) return;

  const imageDesktop = content.imageDesktop;
  const imageMobile = content.imageMobile || imageDesktop;

  return (
    <div
      className={`interstitial-banner-v2 interstitial-banner-v2--width-${content.cardWidth} product-card--fade-in`}
      // ref={(el) => (cardFade = el)}
      style={{
        "--card-width": content.cardWidth,
        "--content-alignment": mapVerticalAlignment(
          content.contentVerticalAlign,
        ),
        "--overlay-opacity":
          content.overlayOpacity === null ? 0.2 : content.overlayOpacity,
        "--index": Math.min(index, 8),
      }}
    >
      <div className="interstitial-banner-v2__inner">
        {content.ctaUrl && (
          <a
            href={content.ctaUrl}
            className="interstitial-banner-v2__card-link"
            tabindex="-1"
          ></a>
        )}
        <div className="interstitial-banner-v2__background">
          {imageDesktop && (
            <picture
              style={{
                "--object-position-desktop": objectPositionFromFocalPoint(
                  imageDesktop.presentation,
                ),
                "--object-position-mobile": objectPositionFromFocalPoint(
                  imageMobile.presentation,
                ),
              }}
            >
              <source
                media="(min-width: 1920px)"
                srcset={getSizedImageUrl(
                  imageDesktop.image.url,
                  `${960 * content.cardWidth}x`,
                )}
              />
              <source
                media="(min-width: 1440px)"
                srcset={getSizedImageUrl(
                  imageDesktop.image.url,
                  `${720 * content.cardWidth}x`,
                )}
              />
              <source
                media="(min-width: 1280px)"
                srcset={getSizedImageUrl(
                  imageDesktop.image.url,
                  `${640 * content.cardWidth}x`,
                )}
              />
              <source
                media="(min-width: 600px)"
                srcset={getSizedImageUrl(imageDesktop.image.url, "1000x")}
              />
              <img
                alt="Collection Demo"
                src={getSizedImageUrl(imageMobile.image.url, "600x")}
              />
            </picture>
          )}
        </div>
        <div className="interstitial-banner-v2__overlay"></div>
        <div className="interstitial-banner-v2__content">
          {content.heading && (
            <RichText
              schema={content.heading}
              className="interstitial-banner-v2__heading"
            />
          )}
          {content.ctaText && (
            <>
              <a
                href={content.ctaUrl}
                className="link interstitial-banner-v2__cta interstitial-banner-v2__cta--mobile"
              >
                {content.ctaText}
              </a>
              <a
                href={content.ctaUrl}
                className="button button--primary interstitial-banner-v2__cta interstitial-banner-v2__cta--desktop"
              >
                {content.ctaText}
              </a>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default InterstitialBannerV2;
